<template>
  <BaseButton variant="black-middle" class="trail-btn" @click.stop="handleTry">
    {{ text }}
    <template #icon>
      <IconMoreRight class="trail-btn__icon" />
    </template>
  </BaseButton>
</template>

<script lang="ts" setup>
import BaseButton from '@/design/components/buttons/base.vue';
import IconMoreRight from '~/design/icons/more-right.svg?component';

import type { CSSProperties } from 'vue';
const props = withDefaults(
  defineProps<{
    text?: string;
    type?: string;
    widthStyle?: CSSProperties;
    handler?: () => void;
  }>(),
  {
    text: '免费试用',
  },
);
const handleTry = () => {
  if (props.handler) {
    props.handler();
    return;
  }
  const userInfo = useUserInfo();
  if (!userInfo.value) {
    navigateTo(
      `/login?redirect=${encodeURIComponent(encodeURIComponent(`${location.origin}/workspace`))}`,
    );
  } else {
    location.href = '/workspace';
  }
};
</script>

<style lang="scss" scoped>
.trail-btn {
  width: 178px;
  position: relative;
  z-index: 1;
}

@media (max-width: $media-mobile) {
  .trail-btn.ss-button {
    gap: 6px !important;
  }

  .trail-btn__icon {
    width: 16px !important;
    height: 16px !important;
    flex-shrink: 0;
  }
}
</style>
